import Webpush from '../pages/profile/webpush/Webpush.vue';
import Footer from './components/footer/Footer.vue';
import Drawer from './components/drawer/Drawer.vue';
import Header from './components/header/Header.vue';
import Cookies from './components/cookies/Cookies.vue';

export default {
  data() {
    return {};
  },
  components: {
    Drawer,
    Header,
    Webpush,
    Footer,
    Cookies,
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    userIsChecked() {
      return this.$store.state.user ? this.$store.state.user.is_checked : null;
    },
    isBlocked() {
      return !!(this.$store.state.user
        && this.$store.state.user.blocked_at !== null && this.$store.state.user.confirmed === true);
    },
    extranet() {
      return this.$store.state.settings.extranet === true;
    },
    loading() {
      return this.$store.state.loading;
    },
    epsCartLength() {
      return this.$store.state.eps.cartLength;
    },
    layout() {
      return this.$store.state.settings.layout;
    },
    bgUrl() {
      return this.$store.state.settings.bgUrl;
    },
    showWebpushPopup() {
      return 'Notification' in window
        && this.$store.state.user
        && this.$store.state.settings.webpush === true
        && this.$store.state.webpush.webpushPopupOpened === true
        && this.$store.state.webpush.webpushFirebaseToken === null
        && this.$store.state.webpush.webpushDeclinedAt === null;
    },
    news() {
      return this.$store.state.settings.news === true;
    },
    instructions() {
      return this.$store.state.settings.instructions === true;
    },
    sales() {
      return this.$store.state.settings.sales === true;
    },
    courses() {
      return this.$store.state.settings.courses === true;
    },
    tickets() {
      return this.$store.state.settings.module_tickets === true;
    },
    isBannersOn() {
      return this.$store.state.settings.module_banners === true;
    },
    isShopOn() {
      return this.$store.state.settings.shop === true;
    },
    /** Верхнее меню */
    topMenuItems() {
      if (this.isAuthenticated && this.userIsChecked) {
        const menu = [
          {
            title: 'Личный кабинет',
            path: '/dashboard',
            icon: 'home',
            showIcon: true,
            showTitle: true,
          },
          {
            title: 'Гарантийные случаи',
            path: '/warranties',
            icon: 'shield-virus',
            showIcon: true,
            showTitle: true,
          },
          {
            title: 'Продажи',
            path: '/sales',
            icon: 'ruble-sign',
            showIcon: true,
            showTitle: true,
          },
          {
            title: 'Призы',
            path: '/prizes',
            icon: 'gift',
            showIcon: true,
            showTitle: true,
          },
          {
            title: 'Заказы',
            path: '/orders',
            icon: 'file-alt',
            showIcon: true,
            showTitle: true,
          },
        ];
        this.news && menu.push({
          title: 'Новости',
          path: '/news',
          icon: 'newspaper',
          showIcon: true,
          showTitle: true,
        });
        this.instructions && menu.push({
          title: 'Инструкции',
          path: '/instructions',
          icon: 'chart-bar',
          showIcon: true,
          showTitle: true,
        });

        this.courses && menu.push({
          title: 'Обучение',
          path: '/courses',
          icon: 'user-graduate',
          showIcon: true,
          showTitle: true,
        });
        this.isShopOn && menu.push({
          title: 'Товары',
          path: '/shop',
          icon: 'shopping-cart',
          showIcon: true,
          showTitle: true,
        });
        return menu;
      }
      if (this.isAuthenticated && !this.userIsChecked) {
        return [
          {
            title: 'Профиль',
            path: '/profile',
            icon: 'user-circle',
          },
        ];
      }
      return [];
    },
    /** Левое мобильное меню в дровере */
    leftMenuItems() {
      if (this.isAuthenticated) {
        let menu = [];
        if (this.userIsChecked) {
          menu = [
            {
              title: 'Призы',
              path: '/prizes',
              icon: 'gift',
            },
            {
              title: 'Заказы',
              path: '/orders',
              icon: 'file-alt',
            },
            {
              title: 'Гарантийные случаи',
              path: '/warranties',
              icon: 'shield-virus',
              showIcon: true,
              showTitle: true,
            },
          ];
          this.sales && menu.push({
            title: 'Продажи',
            path: '/sales',
            icon: 'ruble-sign',
          });
          this.news && menu.push({
            title: 'Новости',
            path: '/news',
            icon: 'newspaper',
          });
          this.isShopOn && menu.push({
            title: 'Товары',
            path: '/shop',
            icon: 'shopping-cart',
          });
          this.instructions && menu.push({
            title: 'Инструкции',
            path: '/instructions',
            icon: 'chart-bar',
            optionalClass: 'long-title',
          });

          this.courses && menu.push({
            title: 'Обучение',
            path: '/courses',
            icon: 'user-graduate',
          });
          this.tickets ? menu.push({
            title: 'Помощь',
            path: '/tickets',
            icon: 'comment-dots',
          }) : menu.push({
            title: 'Помощь',
            path: '/feedback',
            icon: 'comment-dots',
          });
        } else {
          menu = [
            {
              title: 'Профиль',
              path: '/profile',
              icon: 'user-circle',
            },
          ];
        }
        return menu;
      }
      if (this.extranet) {
        return [];
      }
      return [
        {
          title: 'Главная страница',
          path: '/',
          icon: 'home',
        },
        {
          title: 'Помощь',
          path: '/feedback',
          icon: 'question-circle',
        },
        {
          title: 'Войти',
          path: '/login',
          icon: 'sign-in-alt',
        },
      ];
    },
  },
  methods: {
    UserLogout() {
      this.$store.dispatch('UserLogout');
      this.$router.push('/');
    },
  },
  created() {
    this.$store.dispatch('GetSettings');
    this.$store.commit('SetLoading', false);
    this.isBannersOn && this.$store.dispatch('banners/GetBannersList');
  },
};
